import { createContext, useContext, useMemo } from 'react';

const SelectContext = createContext({ onOptionSelect: () => {} });

export const SelectProvider = ({ children, onOptionSelect }) => {
  const value = useMemo(() => ({ onOptionSelect }), [onOptionSelect]);

  return (
    <SelectContext.Provider value={value}>{children}</SelectContext.Provider>
  );
};

export const useSelectContext = () => useContext(SelectContext);
